import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'

export const accountSearch = async ({ params, token, comid, projectID }) => {
  try {
    return await clientPublic
      // .post(`account/search?com_id=${comid}&project_id=${projectID}`, params, {
      .post(`account/search?project_id=${projectID}&showall=active`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
